import { Box, Button, Text, Title } from '@nimbus-ds/components';
import { useTranslationAccount } from 'domains/Account/hooks';
import { ReactComponent as Hero } from './Hero.svg';

interface HandoffStoreProps {
  handleRecoverStore: () => void;
}

function HandoffStore({ handleRecoverStore }: Readonly<HandoffStoreProps>) {
  const t = useTranslationAccount('canceledStorePage');

  return (
    <Box
      display="flex"
      flexDirection={{ lg: 'row', md: 'column', xs: 'column' }}
      gap="16"
      padding="16"
    >
      <Box>
        <Hero width="100%" />
      </Box>
      <Box
        display="flex"
        flexDirection="column"
        alignItems={{ lg: 'flex-start', md: 'center', xs: 'center' }}
        justifyContent="center"
        flex="1"
        gap="9"
      >
        <Box display="flex" flexDirection="column" gap="4">
          <Title>{t('handoffStore.title')}</Title>
          <Text>{t('handoffStore.subTitle')}</Text>
        </Box>
        <Button appearance="primary" onClick={handleRecoverStore}>
          {t('handoffStore.button')}
        </Button>
      </Box>
    </Box>
  );
}

export default HandoffStore;
